<app-form-tags2
  [formControl]="ctrl"
  [label]="label"
  matTooltip="You have to press Enter on your Keyboard to save tag"
  i18n-matTooltip
  matTooltipPosition="above"
  [items]="availableTags"
  [placeholder]="placeholder"
  (valueChange)="onChange($event)"
  [required]="required"
></app-form-tags2>
